<div class="menu-item-container">
  @if (completed) {
    <div class="check-complete"></div>
  }
  <div class="title-container">
    <div class="title-icon {{ iconClass }}"></div>
    <div class="title-text label">
      {{ title }}<br />
      <div [innerHtml]="subtitle" class="sub-title-text"></div>
    </div>
  </div>
  <div
    (click)="menuButtonedClicked($event)"
    [ngClass]="{ disabled: disabled }"
    [title]="disabled ? disabledTooltip : ''"
    class="menu-item-button save"
    >
    {{ buttonText }}
    @if (showSpinner) {
      <span class="spinner"></span>
    }
  </div>
</div>
